import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import useHasAllScopes from 'messaging-management-lib/user/hooks/useHasAllScopes';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ConvertToCloneModal({
  onClickConvert,
  onClose
}) {
  const hasAllScopes = useHasAllScopes();
  const hasEmailAccess = useMemo(() => {
    return hasAllScopes('email-access');
  }, [hasAllScopes]);
  const isFreePortal = useMemo(() => {
    return !hasAllScopes('marketing-email-no-branding') && !hasEmailAccess;
  }, [hasAllScopes, hasEmailAccess]);
  return /*#__PURE__*/_jsxs(Modal, {
    className: "convert-only-modal",
    size: "auto",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.emailClone.convertForClone.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.emailClone.convertForClone.body1"
        })
      }), /*#__PURE__*/_jsxs("p", {
        children: [isFreePortal && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.emailClone.convertForClone.body2.free"
        }), !isFreePortal && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.emailClone.convertForClone.body2.starter"
        })]
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClickConvert,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.emailClone.convertForClone.clone"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.emailClone.convertForClone.cancel"
        })
      })]
    })]
  });
}